import React from "react";
import {
  ConditionElseEntryLine
} from "@sinch/components/application/RatelistBuilder/BuilderTree/components/ConditionElseEntryLine";
import {
  ConditionElseExitLine
} from "@sinch/components/application/RatelistBuilder/BuilderTree/components/ConditionElseExitLine";
import { CrossroadBadge } from "@sinch/components/application/RatelistBuilder/BuilderTree/components/CrossroadBadge";
import {
  useRateBuilderSettings
} from "@sinch/components/application/RatelistBuilder/UtilitiesProviders/RateBuilderSettingsProvider";
import { Box } from "@mui/material";

/**
 * Renders the appropriate connector lines based on item position in the tree
 * and whether it's wrapped in a container. Simplifies conditional rendering logic
 * for different types of visual connectors in the tree structure.
 */
interface ItemConnectorLinesProps {
  isWrapped: boolean;
  position?: string;
}

export const ItemConnectorLines: React.FC<ItemConnectorLinesProps> = ({ isWrapped, position }) => {
  const { mode } = useRateBuilderSettings();
  return (
    <>
      {(mode === "view" || mode === "override") && (
        <Box
          sx={{
            ".SinchRateBuilderTreeItemRoot-wrapper:last-of-type .SinchRateBuilderTreeItemRoot-ifElseItem > div > .SinchRateBuilderTreeItemRoot-ifElseItemContent > &,.SinchRateBuilderTreeItemRoot-entryRate:last-of-type > div > .SinchRateBuilderTreeItemRoot-entryRateContent > &":
              {
                position: "absolute",
                width: "2px",
                borderLeft: "var(--tree-lines-width, 2px) solid var(--lines-color)",
                left: "calc(var(--main-line-offset) * -1 - var(--tree-lines-width, 2px) / 2)",
                height: "calc(50% + 8px)",
                top: "-8px",
              },
          }}
        ></Box>
      )}
      {(!isWrapped || position === "first") && <CrossroadBadge>+</CrossroadBadge>}
      {(mode === "edit" || position !== "last") && isWrapped && <ConditionElseExitLine />}
      {isWrapped && (position === "last" || position === "between") && <ConditionElseEntryLine />}
    </>
  );
};
